const siteMap = new Map([
  ['detail', '/place/detail/analysis']
]);

export default siteMap;
